import { render } from "./DataTablesView.vue?vue&type=template&id=bd9154ba"
import script from "./DataTablesView.vue?vue&type=script&lang=js"
export * from "./DataTablesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__